const baseApiUrl = process.env.NEXT_PUBLIC_BASE_API_URL || '';
const razorPayKey = process.env.NEXT_PUBLIC_RAZORPAY_KEY || '';
const orgId = process.env.NEXT_PUBLIC_ORG_ID || '';
const erpBaseUrl = 'https://erpnext.pwioi.com';
const googleClientId = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || '';

export { baseApiUrl, razorPayKey, orgId, erpBaseUrl, googleClientId };
